import styled from 'styled-components';
import { IconSize, HelpIcon } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { WithPopoverPlacement, WithPopover } from '@ardoq/popovers';
import { ReactNode } from 'react';
import { FlexBox } from '@ardoq/layout';

const LabelHelpIcon = styled(HelpIcon).attrs({
  iconSize: IconSize.MEDIUM,
})`
  color: ${colors.iconAction};
  cursor: pointer;
  &:hover {
    color: ${colors.iconActionHover};
  }
`;

const PopoverWrapper = styled(FlexBox).attrs({
  flexDirection: 'column',
  gap: 'medium',
})`
  width: ${'279px'};
`;

type LabelHelpIconWithPopoverProps = {
  content: ReactNode;
};

export const LabelHelpIconWithPopover = ({
  content,
}: LabelHelpIconWithPopoverProps) => {
  return (
    <WithPopover
      content={() => <PopoverWrapper>{content}</PopoverWrapper>}
      preferredPlacement={WithPopoverPlacement.TOP}
    >
      <LabelHelpIcon />
    </WithPopover>
  );
};

export const LABEL_ICON_SELECTOR = LabelHelpIcon.toString();
